module.exports = __webpack_public_path__ + "static/Dental implants intraoral before-b0a3e634c407b5585591792160a9944e.jpg";